<script>
import routerMixin from 'widget/mixins/routerMixin';

export default {
  name: 'SecondaryNavBar',
  mixins: [routerMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    pageTitle() {
      if (this.title) {
        return this.title;
      }

      const routeTitleMap = {
        'article-viewer': this.$t('ARTICLE'),
        'prechat-form': this.$t('PRE_CHAT_FORM_TITLE'),
        'unread-messages': this.$t('UNREAD_MESSAGES'),
        campaigns: this.$t('CAMPAIGN'),
      };

      return routeTitleMap[this.$route.name] || '';
    },
  },
  methods: {
    goBack() {
      // 如果有历史记录，返回上一页
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        // 否则导航到主页
        this.replaceRoute('home');
      }
    },
  },
};
</script>

<template>
  <div
    class="secondary-navbar bg-white border-b border-b-[rgba(15,15,15,0.06)] dark:bg-n-solid-1 dark:border-n-solid-3 px-4 py-2 flex items-center"
  >
    <button
      class="back-button w-8 h-8 flex items-center justify-center"
      @click="goBack"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
    <h1
      class="text-lg font-semibold flex-grow text-center pr-8 text-n-slate-12 dark:text-n-slate-12"
    >
      {{ pageTitle }}
    </h1>
  </div>
</template>

<style scoped>
.secondary-navbar {
  height: 48px;
}
</style>
